import React from 'react'
import Link from 'gatsby-link'
import { Timeline } from 'react-twitter-widgets'
import Helmet from 'react-helmet';

const ArticleIndexPage = ({pathContext, data}) => {
    const { posts, page, pagesSum, prevPath, nextPath } = pathContext;
      
    return (
<div className="container main-section">
  <Helmet title="Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer."/>
  <div className="row">
    <a name="top"></a>
    <div className="col-sm-8 level-one">
      {posts.map((post, index) =>
        <div key={post.id}>
          <article className="synopsis">
            <Link to={post.fields.slug}>
              <header>
                <h2 className="withDate">{post  .frontmatter.title}</h2>
                <p><time dateTime={post.frontmatter.date}>{post.frontmatter.date}</time></p>
              </header>
            </Link>
            <p className="excerpt">
              {post.excerpt}
            </p>
            <Link to={post.fields.slug}>Read more...</Link>
          </article>
        </div>
      )}
      {(nextPath) && <a href={nextPath}>&larr; Older Posts</a>}
      {(nextPath && prevPath) && <span> &#x25CB; </span>}
      {(prevPath) && <a href={prevPath}>Newer Posts &rarr;</a>}
      <p><br/><br/></p>
    </div>
    <div className="col-sm-4 level-two">
      <Timeline dataSource={{sourceType: "profile", screenName: "pkimbrel"}}
                options={{username:"reactjs",height: "500"}} />
    </div>
  </div>
</div>
)}

export default ArticleIndexPage



// WEBPACK FOOTER //
// ./src/templates/article-listing.js